import { localeData, LocaleData } from '../../domain'

export function usePickerLocaleData(): Record<string, LocaleData> {
  return {
    localeData,
  }
}
